/**
 * Leitura do modo economia sem React — importável por módulos de baixo nível
 * (camera-publish-bitrate etc.) sem criar ciclo com `economyMode.tsx`.
 */
export const ECONOMY_MODE_STORAGE_KEY = 'evolutto-meet-economy-mode';

export function readEconomyModeEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(ECONOMY_MODE_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
